<template>
    <div class="banner-list">
        <div class="td-flex mb-2">
            <h1 class="td-h2">Banner Ads</h1>
            <button v-if="allBanners.length > 0" title="Add a Banner" class="td-btn primary icon-left " @click="openAddModal"><icon name="faPlus" type="solid"></icon>Add Banner</button>
        </div>
        <div class="banners-container" v-if="allBanners.length > 0">
            <template v-for="banner in allBanners" :key="banner.id">
                <banner :banner="banner" :services-number="servicesDisplayNumber" :all-services="allServices" @update:banner="updateBanner" :is-admin="isAdmin"></banner>
            </template>
        </div>
        <div v-else class="td-banner warning no-icon mt-0 ml-0">
            <div class="td-flex">
                <p>No banners found.</p>
                <button title="Add a Banner" class="td-btn primary icon-left slim" @click="openAddModal"><icon name="faPlus" type="solid"></icon>Add Banner</button>
            </div>
        </div>
        <edit-banner v-if="showAdd" @close-edit="cancelAdd" @submit-edit="submitEdit" :all-services="allServices" :account-id="accountId"></edit-banner>
    </div>
</template>

<script>
    import script from './BannerList';
    export default script;</script>

<style lang="less">
    @import "./BannerList.less";
</style>